import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-padded-layout",
  templateUrl: "./padded-layout.component.html",
  styleUrls: ["./padded-layout.component.scss"]
})
export class PaddedLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
